export default __webpack_public_path__ + "static/media/date_icon.ccf55969.svg";